<template>
  <el-dialog :visible="show" append-to-body :title="row ? '修改城市' : '新增城市'" width="500px" @close="closeDialog">
    <el-form label-width="100px" ref="vForm" :model="vForm">
      <el-form-item label="排序" prop="sort" :rules="{ required: true, message: '排序必填' }">
        <el-input v-model="vForm.sort"></el-input>
      </el-form-item>
      <el-form-item label="镇级名称" prop="name" :rules="{ required: true, message: '镇级名称必填' }">
        <el-input v-model="vForm.name"></el-input>
      </el-form-item>
      <el-form-item label="PC封面" prop="ext.cover_img" :rules="{ required: true, message: 'PC封面必填' }">
        <u-image
          width="300"
          height="100"
          v-model="cover_img"
          @change="
            (img) => {
              vForm.ext.cover_img = img.key;
              $refs.vForm.validateField('ext.cover_img');
            }
          "
        />
        <div class="v-form-tips">尺寸1920*700px</div>
      </el-form-item>
      <el-form-item label="小程序封面" prop="ext.cover_img_mobile" :rules="{ required: true, message: '小程序封面必填' }">
        <u-image
          width="375"
          height="250"
          v-model="cover_img_mobile"
          @change="
            (img) => {
              vForm.ext.cover_img_mobile = img.key;
              $refs.vForm.validateField('ext.cover_img_mobile');
            }
          "
        />
        <div class="v-form-tips">尺寸750*500px</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    pid: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      doSubmitLoading: false,
      vForm: {
        id: '',
        name: '',
        sort: 0,
        pid: this.pid,
        level: 2,
        ext: {
          cover_img: '',
          cover_img_mobile: '',
        },
      },
      cover_img: { key: '', preview: '' },
      cover_img_mobile: { key: '', preview: '' },
    };
  },

  created() {
    if (this.row) {
      for (let key in this.vForm) {
        this.vForm[key] = this.row[key];
      }
      this.cover_img = {
        key: this.row.ext.cover_img,
        preview: this.row.ext.cover_img_preview,
      };
      this.cover_img_mobile = {
        key: this.row.ext.cover_img_mobile,
        preview: this.row.ext.cover_img_mobile_preview,
      };
    }
  },

  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },

    //提交表单
    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.$refs.vForm.validate();
        await this.api.region[this.row ? 'areaEdit' : 'areaAdd'](this.vForm);
        this.$store.dispatch('user/getAreaList', true);
        this.$message.success(!this.row ? '添加成功' : '修改成功');
        this.$emit('success');
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>
